if (!customElements.get('product-description-collapse')) {
  customElements.define('product-description-collapse', class extends HTMLElement {
    constructor() {
      super();
      this.toggleDescription = () => {
        const expanded = this.dataset.expanded !== 'true';
        this.dataset.expanded = String(expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.label.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        this.updateButtonVisibility();
      };
    }

    connectedCallback() {
      this.content = this.querySelector('.product-description-collapse__content');
      this.button = this.querySelector('.product-description-collapse__toggle');
      this.label = this.querySelector('[data-description-label]');
      if (!this.content || !this.button || !this.label) return;
      this.dataset.ready = 'true';
      this.button.addEventListener('click', this.toggleDescription);
      this.observer = new ResizeObserver(() => this.updateButtonVisibility());
      this.observer.observe(this.content);
      this.updateButtonVisibility();
      if (document.fonts) document.fonts.ready.then(() => this.updateButtonVisibility());
    }

    updateButtonVisibility() {
      if (!this.isConnected) return;
      this.button.hidden = this.dataset.expanded !== 'true' &&
        this.content.scrollHeight <= this.content.clientHeight + 1;
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggleDescription);
      this.observer?.disconnect();
    }
  });
}
